import ListJoonDevices from './ListJoonDevices';

export default ListJoonDevices;
